// extracted by mini-css-extract-plugin
export default {"notification":"notification_notification__bGMNb","fadein":"notification_fadein__XHAfY","fadeout":"notification_fadeout__13t-E"};